import React from 'react';
import { Warning } from '@mui/icons-material';
import { Box, Typography, Button } from '@mui/material';
import Divider from '@mui/material/Divider';

interface Props {
  onCreateProductQuote: VoidFunction;
}

export const EmptyProducts = ({ onCreateProductQuote }: Props) => {
  const render = [{ group: 'Service Contract' }, { group: 'Insurance' }, { group: 'Other' }];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      {render.map(({ group }) => (
        <>
          <Box sx={{ display: 'flex', flexDirection: 'column' }} key={group}>
            <Typography variant="subtitle2" component="span">
              {group}
            </Typography>

            <Box sx={{ display: 'grid', justifyContent: 'flex-start', gridTemplateColumns: 'auto auto', gap: '1rem' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Warning color="warning" />
                <Typography>Nothing sold. Potential revenue opportunity not utilized</Typography>
              </Box>
              <Button variant="contained" onClick={onCreateProductQuote}>
                Create Product Quote
              </Button>
            </Box>
          </Box>

          <Divider />
        </>
      ))}
    </Box>
  );
};
